import {
  SHOP_STATUS_OPEN_ONLINE,
  SHOP_STATUS_OPEN_OFFLINE,
  SHOP_STATUS_CLOSED_ONLINE,
  SHOP_STATUS_CLOSED_OFFLINE,
  SHOP_STATUS_CLOSED_ADHOC_ONLINE,
  SHOP_STATUS_CLOSED_ADHOC_OFFLINE,
  SHOP_OPENED_MODE_ADHOC_CLOSED,
} from '../constants/status';

const getDealerStatus = dealer => {
  const { isOpened, isActive, isOpenedMode } = dealer;

  if (isOpened && (!isActive || !dealer.products || dealer.products.length === 0)) {
    return SHOP_STATUS_OPEN_OFFLINE;
  }

  if (!isOpened && isActive && isOpenedMode === SHOP_OPENED_MODE_ADHOC_CLOSED) {
    return SHOP_STATUS_CLOSED_ADHOC_ONLINE;
  }

  if (!isOpened && !isActive && isOpenedMode === SHOP_OPENED_MODE_ADHOC_CLOSED) {
    return SHOP_STATUS_CLOSED_ADHOC_OFFLINE;
  }

  if (isOpened && isActive) {
    return SHOP_STATUS_OPEN_ONLINE;
  }

  if (!isOpened && !isActive) {
    return SHOP_STATUS_CLOSED_OFFLINE;
  }

  if (!isOpened && isActive) {
    return SHOP_STATUS_CLOSED_ONLINE;
  }

  return null;
};

export default getDealerStatus;



// WEBPACK FOOTER //
// ../utils/functions/dealer-status.js